import React from 'react';
import PropTypes from 'prop-types';
import './SimpleButton.css';

/**
 * A simple button.
 */
 
const spinnerDiv = bgCol => <div className="processing-spinner"><div className="bounce1" style={{backgroundColor:bgCol}}></div><div className="bounce2" style={{backgroundColor:bgCol}}></div><div className="bounce3" style={{backgroundColor:bgCol}}></div></div>;

const SimpleButton = ({ onClick, color, children, spinner }) => {
	return (
		<button style={{color: color }} className="simpleButton" onClick={onClick}>
		{
			spinner?
			spinnerDiv(color):
			children
		}
		</button>
	)
}

SimpleButton.propTypes = {
	/** Button label */
	children: PropTypes.oneOfType([
	    PropTypes.string,
	    PropTypes.array
	  ]).isRequired,
	/** Label Color */
	color: PropTypes.string,
	/** Spinner */
	spinner: PropTypes.bool,
	/** Gets called when the user clicks on the button */
	onClick: PropTypes.func
}

SimpleButton.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a SimpleButton Component!', event.target);
	},
	/* eslint-enable no-console */
	spinner: false,
	color: '#fff'
}

export default SimpleButton;


// WEBPACK FOOTER //
// ./src/components/atoms/SimpleButton/SimpleButton.js